import React, { useCallback, useEffect, useState } from 'react';
import {
  CHAT_FOLLOWUP_NOTIFICATION_OPTIONS,
  fetchChatFollowupNotificationPreference,
  getChatFollowupNotificationLabel,
  normalizeChatFollowupNotificationMode,
  updateChatFollowupNotificationPreference,
} from './chatFollowupApi';

const ICON_BY_MODE = Object.freeze({
  all: 'fa-solid fa-bell',
  mine: 'fa-solid fa-user-check',
  off: 'fa-solid fa-bell-slash',
});

const ChatFollowupNotificationMenu = ({
  menu,
  onClose,
  onPreferenceChange,
  toastError,
  toastSuccess,
}) => {
  const [mode, setMode] = useState('mine');
  const [busyMode, setBusyMode] = useState('');

  useEffect(() => {
    if (!menu) return undefined;
    const controller = new AbortController();
    fetchChatFollowupNotificationPreference({ signal: controller.signal })
      .then((preference) => setMode(normalizeChatFollowupNotificationMode(preference.mode)))
      .catch((error) => {
        if (controller.signal.aborted) return;
        toastError?.(error?.message || 'AIチャット通知設定を取得できませんでした。');
      });
    return () => controller.abort();
  }, [menu, toastError]);

  const handleSelect = useCallback(
    async (nextMode) => {
      const normalizedMode = normalizeChatFollowupNotificationMode(nextMode);
      if (busyMode) return;
      setBusyMode(normalizedMode);
      try {
        const preference = await updateChatFollowupNotificationPreference({ mode: normalizedMode });
        setMode(preference.mode);
        onPreferenceChange?.(preference);
        toastSuccess?.(`AI通知: ${getChatFollowupNotificationLabel(preference.mode)}`);
        onClose?.();
      } catch (error) {
        toastError?.(error?.message || 'AIチャット通知設定を更新できませんでした。');
      } finally {
        setBusyMode('');
      }
    },
    [busyMode, onClose, onPreferenceChange, toastError, toastSuccess],
  );

  if (!menu) return null;

  return (
    <div className="message-menu-overlay" onClick={onClose}>
      <div
        className="message-menu target-menu chat-followup-notification-menu"
        style={{ top: menu.y, left: menu.x }}
        onClick={(event) => event.stopPropagation()}
      >
        {CHAT_FOLLOWUP_NOTIFICATION_OPTIONS.map((option) => {
          const selected = option.mode === mode;
          const disabled = Boolean(busyMode);
          return (
            <button
              key={option.mode}
              type="button"
              className={`message-menu__item${selected ? ' is-selected' : ''}`}
              disabled={disabled}
              aria-pressed={selected ? 'true' : 'false'}
              onClick={() => handleSelect(option.mode)}
            >
              <i className={selected ? 'fa-solid fa-check' : ICON_BY_MODE[option.mode]} aria-hidden="true" />
              <span>{option.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ChatFollowupNotificationMenu;
